import React, { Component } from 'react';
import './style.css';

class UserTransaction extends Component {
  constructor(props){
    super(props)

    this.state={
      
    };
  }


  getGiftcouponByUser(data){
    this.props.getGiftcouponByUser(data);
  }

  memberList(){
    this.props.backMemberList();
  }

  render() {
    let studyList="";
    let transactionItem = "";
    let SNo =0;
    if(this.props.UserTranactionData && this.props.UserTranactionData.length){
      let studies = this.props.UserTranactionData;
      studyList = Object.keys(studies).map((item, index) => {
        transactionItem = studies[item];

        let viewAction ="";
         if(transactionItem.paymentType === "GiftCouponOnline" && transactionItem.paymentStatus === "success"){
          viewAction = <button className = "participatbtn" type="button" onClick={this.getGiftcouponByUser.bind(this, transactionItem)}>ViewCoupon</button>
         }else{
          viewAction = <div>{transactionItem.paymentStatus.toUpperCase()}</div>
         }
          
        SNo = SNo+1;
        return <tr  key={index}>
          <td >{SNo}</td>
          <td >{transactionItem.totalAmount+" USD"}</td>
          <td >{transactionItem.totalPoints}</td>
          <td >{transactionItem.paymentType}</td>
          <td >{transactionItem.paymentStatus}</td>
          <td >{transactionItem.updatedAt.split("T")[0] + " "+transactionItem.updatedAt.split("T")[1].split(".")[0] }</td>
          {/* <td>{viewAction}</td> */}
          </tr>
      });
    }

    return (
      
        <div className = "paymentlist">
        <div className = "paymentlistbackground">
        <div className = "usertable"><h1> Transaction History </h1></div>
            <div className = "studytable">
            <br/><button  className = "UserTxnbackbutton" onClick={this.memberList.bind(this)}>Back</button>
            <table className ="paymentTable">
            <tr className = "">
            <th className = "">S.no.</th>
            <th className = "">Amount</th>
            <th className = "">Points</th>
            <th className = "">Payment Type</th>
            <th className = "">Payment Status</th>
            <th className = "">Date & Time</th>
            {/* <th className = "">Action</th> */}
            </tr>
            {studyList}
            </table>
            </div>
        </div>
        </div>
      
    );
  }
}
export default UserTransaction;



// WEBPACK FOOTER //
// ./src/components/members/userTransaction.js